export default {
  callingAPI: false,
  searching: '',
  serverURI: 'http://teste.jlugao.com/api/',
  // serverURI: 'http://sandbox.mundomaker.cc/api/',
  user: null,
  token: null,
  company: null,
  selectedRole: null,
  selectedUser: null,
  userInfo: {
    messages: [{ 1: 'test', 2: 'test' }],
    notifications: [],
    tasks: []
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js